import { memo } from 'react'
import { clsx } from 'clsx'

import css from './Footer.module.scss'

interface FooterProps {
  className?: string
}

function Footer({ className }: FooterProps) {
  return (
    <footer className={clsx('Footer', css.root, className)}>
      <span className={css.text}>Monks</span>
    </footer>
  )
}

export default memo(Footer)
